export default __webpack_public_path__ + "static/media/Brigand's Armbands of Woven Clouds.999edd43.jpg";